class DevelopmentProperties {
	/** @var {HTMLElement} */
	#$root;

	/** @var {{ availability: string, display: bool, id: string }[]} */
	#properties = [];

	constructor( $root ) {
		this.#$root = $root;

		this.#mapProperties();
		this.#bindEvents();
	}

	/**
	 *
	 * @return {{ properties: NodeListOf<HTMLElement>, error: HTMLElement, toggle: HTMLElement }}
	 */
	get #$elements() {
		return {
			properties: this.#$root.querySelectorAll( '.development-properties__grid .property-card' ),
			error: this.#$root.querySelector( '.development-properties__error' ),
			toggle: this.#$root.querySelector( '#development-properties__available' ),
		};
	}

	/**
	 * Maps the relevant property details into this instance for local filtering.
	 *
	 * @return {void}
	 */
	#mapProperties() {
		if ( ! this.#$elements.properties ) {
			return;
		}

		this.#$elements.properties.forEach(
			( $property ) => {
				this.#properties.push( {
					id: $property.dataset.id,
					availability: $property.dataset.availability,
					display: true,
				} );
			}
		)
	}

	/**
	 * Collective grouping of event bindings for all elements.
	 *
	 * @return {void}
	 */
	#bindEvents() {
		this.#$elements.toggle.addEventListener( 'change', ( event ) => this.#filterProperties( event ) );
	}

	/**
	 * Filter against cached properties to create a truthful source for
	 * visibility and then iterate over the elements to update them accordingly.
	 *
	 * @param {Event} event
	 */
	#filterProperties( event ) {
		const visiblePropertyIds = this.#properties.filter( ( property ) => {
			if ( !! event.target.checked ) {
				return 'available' === property.availability;
			}

			return true;
		} ).map( ( { id } ) => id );

		this.#$elements.properties.forEach( ( $property ) => {
			$property.style.display = visiblePropertyIds.includes( $property.dataset.id ) ? 'flex' : 'none';
		} );

		this.#$root.dataset.hasProperties = visiblePropertyIds.length > 0 ? 'true' : 'false';
	}
}

/**
 * Default initialiser that handles instantiating the class instances, as long
 * as we have elements provided.
 */
export default function() {
	const $developments = document.querySelectorAll( '.development-properties' );

	if ( ! $developments ) {
		return;
	}

	$developments.forEach(
		( $development ) => new DevelopmentProperties( $development )
	);
}
